import React, { useContext, useState } from 'react';
import appLabels from '../../utils/appLabels';
import Modal from '../../common/Modal/Modal';
import { TabGroup, Tab } from '../TabGroup/TabGroup';
import PickupTabForm from './PickupTabForm';
import DeliveryAddressList from './DeliveryAddressList';
import { PreferencesContext, PreferencesContextType } from './PreferencesContext';
import { get } from 'lodash';

const SelectFulfillmentMethod = ({ preferredData, onClose }) => {
  const [showAddressList, setShowAddressList] = useState(true);
  const currentPreferencesContext = useContext(PreferencesContext) as PreferencesContextType;

  const toggleAddressList = () => setShowAddressList(!showAddressList);
  const startingTab: number =
    get(currentPreferencesContext, 'preferencesData.fulfillmentTypes.0.value') === 'DELIVERY' ? 0 : 1;
  return (
    <Modal
      titleText={appLabels.SelectFulfillmentMethod.modalTitle}
      description=""
      show={true}
      onClose={onClose}
      fillScreen={true}
    >
      <TabGroup startingTab={startingTab}>
        <Tab header={appLabels.SelectFulfillmentMethod.deliveryTabHeader}>
          <DeliveryAddressList onSave={onClose} />
        </Tab>
        <Tab header={appLabels.SelectFulfillmentMethod.pickupTabHeader}>
          <PickupTabForm preferredData={preferredData} onSave={onClose} />
        </Tab>
      </TabGroup>
    </Modal>
  );
};

export default SelectFulfillmentMethod;
